module.exports = __webpack_public_path__ + "assets/media/day33.7c4fe00d.mp3";